module.exports = __webpack_public_path__ + "static/media/wood_floor_entrance.bb70b725.png";